import { getManilaDate } from "../rbim-questionnaire/questionnaire-model";
import type { AddNewDataFormValues } from "./modules/add-new-data/lib/schema";

export function withCurrentManilaDateEncoded(
  values: AddNewDataFormValues,
  now = new Date(),
): AddNewDataFormValues {
  return {
    ...values,
    encoding: {
      ...values.encoding,
      dateEncoded: getManilaDate(now),
    },
  };
}
